import { render, staticRenderFns } from "./ChatLogCS.vue?vue&type=template&id=b16f72f8&"
import script from "./ChatLogCS.vue?vue&type=script&lang=js&"
export * from "./ChatLogCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports